/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const ForgotPasswordCard = ({ switchScreen, managedLogin = false }) => {
  switchScreen(false);
  const loginRedirect = encodeURIComponent(window.location.href);
  window.location = `${
    process.env.APP_AV_VC_PATH
  }/reset-password-request?login=${loginRedirect}&isManager=${managedLogin || false}`;
  return null;
};

ForgotPasswordCard.propTypes = {
  switchScreen: PropTypes.func.isRequired,
  managedLogin: PropTypes.bool,
};

ForgotPasswordCard.defaultProps = {
  managedLogin: false,
};

export default withRouter(ForgotPasswordCard);
